import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { FailedComponent } from './board/pages/failed/failed.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { NotFoundComponent } from './app-pages/not-found/not-found.component';
import { TermsOfServiceComponent } from './app-pages/legal/terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './app-pages/legal/privacy-policy/privacy-policy.component';
import { AppPickerComponent } from './app-pages/app-picker/app-picker.component';
import { AppLoadingComponent } from './app-pages/app-loading/app-loading.component';
import { QuickBooksCallbackComponent } from './app-pages/quickbooks-callback/quickbooks-callback.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LandingPageComponent
  },
  {
    // Authentication only. Which application the user enters as is decided one
    // level down by BoardAccessGuard (see board-routing.module.ts), so that it
    // runs after MsalGuard rather than racing it.
    path: 'dashboard',
    loadChildren: () => import('./board/board.module').then(m => m.BoardModule),
    canActivate: [MsalGuard]
  },
  {
    // Post-login resolution step: works out how many applications the user has
    // and forwards to the dashboard, the picker, or /no-access.
    path: 'loading',
    component: AppLoadingComponent,
    canActivate: [MsalGuard]
  },
  {
    // Only reached when there is a genuine choice to make.
    path: 'select-app',
    component: AppPickerComponent,
    canActivate: [MsalGuard]
  },
  {
    // Where Intuit returns the browser after consent, carrying a single-use
    // code. MsalGuard only: every additional guard is a chance to redirect and
    // discard the query string. Must stay above the '**' route below, which
    // would otherwise swallow it and drop the code on the landing page.
    path: 'quickbooks/callback',
    component: QuickBooksCallbackComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'no-access',
    component: NotFoundComponent
  },
  {
    path: 'home',
    component: LandingPageComponent
  },
  {
    path: 'login-failed',
    component: FailedComponent
  },
  // Public legal documents. No guard: these URLs are given to third parties
  // (Intuit's app review requires an EULA and a privacy policy URL) and must be
  // readable by anyone, signed in or not. Deliberately unlinked from the app's
  // navigation — reachable only by direct URL. Must stay above the '**' route
  // below, which would otherwise swallow them and redirect to the landing page.
  {
    path: 'terms',
    component: TermsOfServiceComponent
  },
  {
    path: 'privacy',
    component: PrivacyPolicyComponent
  },

  {
    path: '**',
    redirectTo: '/'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
            // Don't perform initial navigation in iframes or popups
            initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
